define('settings/lib/plugins/plugins',['require','knockout','bowser','mixpanel-helper'],function (require) {
    var ko = require('knockout');
    var bowser = require('bowser');
    var mixpanelHelper = require('mixpanel-helper');

    return function () {
        var self = this;

        self.bowser = bowser;
        self.isWindows = ko.observable(navigator.userAgent.toLowerCase().indexOf('windows') > -1);
        self.googleCalendarLink = ko.observable();
        self.googleCalendarLink('https://www.gotomeeting.com/features/quick-one-click-meetings');

        self.isOutlookPluginVisible = ko.computed(function () {
            return true;
        });

        self.isGoogleCalendarPluginVisible = ko.computed(function () {
            return true;
        });

        self.clickDownload = function (link, message) {
            mixpanelHelper.trackLinkNewTab(link, message, null, self.bowser.safari);
        };
    };
});

